(function ($) {
	/* ---------------------------------------
	メインビジュアル　高さ固定
--------------------------------------- */
	$(window).on('load resize', function () {
		var hsize = $(window).height();
		$('.top_main_visual').css('height', hsize + 'px');
	});

	/* ---------------------------------------
		画像読み込み管理クラス
	--------------------------------------- */
	for (var i = 0; i < 3; i++) {
		var img = $('<img>');
		img.load(function () {
			$('.top_main_visual').delay(1000).queue(function () {
				$(this).addClass('start');
			});
			$('.top_main_visual-image').delay(2000).queue(function () {
				$(this).addClass('start');
			});
			$('.top_main_visual-text').delay(3000).queue(function () {
				$(this).addClass('move');
			});
			$('.top_main_visual-scroll').delay(6000).queue(function () {
				$(this).addClass('move');
			});
			$('.top_main_visual .-next-content').delay(6500).queue(function () {
				$(this).addClass('show');
			});
		});
		img.attr('src', $('img').eq(i).attr('src'));
	};

	/* ---------------------------------------
		pagepiling 1ページスクロール
	--------------------------------------- */
	$('.container').pagepiling({
		menu: '.nav_global_top',
		sectionSelector: '.top_content',
		anchors: ['top', 'about', 'values', 'performance', 'partners', 'contact'],
		navigation: false
	});

	/* ---------------------------------------
		タブ切り替え
	--------------------------------------- */
	$(function () {
		let tabs = $(".tab");
		$(".tab").on("click", function () {
			$(".tab").removeClass("current");
			$(this).addClass("current");
			const index = tabs.index(this);
			$(".tab_content").removeClass("show").eq(index).addClass("show");
		})
	})
	/* ---------------------------------------
	end
	--------------------------------------- */
})(jQuery);